/* eslint-disable */
const COLOR_YELLOW_105 = "#f2b400";
const COLOR_BROWN_105 = "#a17247";

const COLOR_RED_100 = "#e6323c";
const COLOR_YELLOW_100 = "#ffbe00";
const COLOR_GREEN_100 = "#4caf50";
const COLOR_GREEN_900 = "#1b5e20";
// The brand red darkened, for a fill that must read as the same red without being COLOR_ACCENT.
const COLOR_RED_900 = "#8f1f25";
const COLOR_BLUE_100 = "#4681b4";
const COLOR_GREY_100 = "#788282";
const COLOR_BROWN_100 = "#aa784b";
const COLOR_TEAL_100 = "#009688";
const COLOR_BURNT_ORANGE_100 = "#fa6900";
const COLOR_CUSTOM_BLUE_100 = "#0a6d86";
const COLOR_MIDNIGHT_BLUE_100 = "#2d4155";

const COLOR_BLUE_80 = "#6b9ac3";

const COLOR_BLUE_65 = "#86adce";

const COLOR_RED_50 = "#f2989d";
const COLOR_YELLOW_50 = "#ffde7f";
const COLOR_GREEN_50 = "#a5d7a7";
const COLOR_BLUE_50 = "#a2c0d9";
const COLOR_GREY_50 = "#bbc0c0";
const COLOR_BROWN_50 = "#d4bba5";
const COLOR_TEAL_50 = "#7fcac3";
const COLOR_BURNT_ORANGE_50 = "#fcb47f";
const COLOR_CUSTOM_BLUE_50 = "#84b6c2";
const COLOR_MIDNIGHT_BLUE_50 = "#96a0aa";

const COLOR_BLUE_45 = "#abc6dd";

const COLOR_RED_25 = "#f8cbce";
const COLOR_YELLOW_25 = "#ffeebf";
const COLOR_GREEN_25 = "#d2ebd3";
const COLOR_BLUE_25 = "#d0dfec";
const COLOR_GREY_25 = "#dddfdf";
const COLOR_BROWN_25 = "#e9ddd2";
const COLOR_TEAL_25 = "#bfe4e1";
const COLOR_BURNT_ORANGE_25 = "#fdd98f";
const COLOR_CUSTOM_BLUE_25 = "#c1dae0";
const COLOR_MIDNIGHT_BLUE_25 = "#cacfd4";

const COLOR_RED_15 = "#fbe0e1";
const COLOR_YELLOW_15 = "#fff5d8";
const COLOR_GREEN_15 = "#e4f3e4";
const COLOR_BLUE_15 = "#e3ecf3";
const COLOR_GREY_15 = "#eaecec";
const COLOR_BROWN_15 = "#f2eae4";
const COLOR_TEAL_15 = "#d8efed";
const COLOR_BURNT_ORANGE_15 = "#fee8d8";
const COLOR_CUSTOM_BLUE_15 = "#dae9ec";
const COLOR_MIDNIGHT_BLUE_15 = "#dfe2e5";

const COLOR_YELLOW_10 = "#fff8e5";

const COLOR_YELLOW_5 = "#fffbf2";

const TRANSPARENCY_100 = "ff";
const TRANSPARENCY_90 = "e6";
const TRANSPARENCY_80 = "cc";
const TRANSPARENCY_75 = "bf";
const TRANSPARENCY_70 = "b3";
const TRANSPARENCY_60 = "99";
const TRANSPARENCY_50 = "80";
const TRANSPARENCY_40 = "66";
const TRANSPARENCY_30 = "4d";
const TRANSPARENCY_25 = "40";
const TRANSPARENCY_20 = "33";
const TRANSPARENCY_10 = "1a";
const TRANSPARENCY_0 = "00";

// Basic Theme Colors
export const COLOR_PRIMARY = COLOR_BLUE_100;
export const COLOR_SECONDARY = COLOR_BLUE_100;
export const COLOR_ACCENT = COLOR_RED_100;
export const COLOR_WARNING = COLOR_YELLOW_105;
export const COLOR_DISABLED = COLOR_GREY_25;
export const COLOR_BUTTON = COLOR_RED_100;

// Dark theme semantic slots (Vuetify `themes.dark`).
// Lighter blue tints read better on a dark surface; accent/warning stay vivid.
// Tune during dark-mode visual QA (see docs/architecture/theming.md).
export const COLOR_PRIMARY_DARK = COLOR_BLUE_80;
export const COLOR_SECONDARY_DARK = COLOR_BLUE_80;
// Dimmer red for dark mode: the full-strength brand red reads as too bright on
// a dark surface.
export const COLOR_ACCENT_DARK = "#c62f38";
export const COLOR_WARNING_DARK = COLOR_YELLOW_100;

export const COLOR_GREEN = "#4caf50";
export const COLOR_LIGHT_BLUE_GRAY = "#a8bac7";
export const COLOR_LIGHT_ORANGE = "#ffcbb7";

export const COLOR_STANDARD_RED = "#ff0000";
export const COLOR_STANDARD_BLACK = "#000000";
export const COLOR_STANDARD_WHITE = "#ffffff";

// Common
export const COLOR_BUTTON_RED = COLOR_RED_100;
export const COLOR_BUTTON_GREEN = COLOR_GREEN_100; 
export const COLOR_BUTTON_YELLOW = COLOR_YELLOW_105;
export const COLOR_BUTTON_GREY = COLOR_GREY_100;
export const COLOR_BUTTON_WHITE = COLOR_STANDARD_WHITE;
export const COLOR_BUTTON_DISABLED = COLOR_GREY_25;
export const COLOR_BUTTON_LINK = COLOR_CUSTOM_BLUE_50;
export const COLOR_BUTTON_LINK_ACTION = COLOR_RED_25;

export const COLOR_TEXT_BUTTON_RED = COLOR_RED_100;
export const COLOR_TEXT_BUTTON_DISABLED = COLOR_GREY_100;
export const COLOR_TEXT_BUTTON_GREEN = COLOR_GREEN_100;
export const COLOR_TEXT_BUTTON_BLUE = COLOR_BLUE_100;

export const COLOR_BASE_DIALOG_BACKGROUND = COLOR_GREY_25;
export const COLOR_TABLE_HEADER = COLOR_GREY_25;

// Dark-mode surface variants. Pair each with its light counterpart via `themed()`
// (see src/utils/Theme.ts). #1e1e1e = Vuetify dark card; #2c2c2c = slightly elevated
// (headers/banners); #121212 = Vuetify dark background.
export const COLOR_SURFACE_DARK = "#1e1e1e";
export const COLOR_SURFACE_ELEVATED_DARK = "#2c2c2c";
// Dark-mode app-bar/header: a muted brand blue that reads as a header (the light-blue
// `primary` looks out of place on a dark surface).
export const COLOR_APP_BAR_DARK = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_BASE_DIALOG_BACKGROUND_DARK = COLOR_SURFACE_ELEVATED_DARK;
export const COLOR_TABLE_HEADER_DARK = COLOR_SURFACE_ELEVATED_DARK;
// A clickable list row under the pointer in dark mode. Vuetify's elevation shadows are black in both
// themes, so the hover raise is invisible on dark surfaces; the row lightens instead, as the project
// and settings lists do. Light mode keeps the shadow and needs no colour.
export const COLOR_LIST_ROW_HOVER_DARK = COLOR_SURFACE_ELEVATED_DARK;
// Login button on the dark login page: a soft off-white, since stark white glares against the
// dark gradient.
export const COLOR_LOGIN_BUTTON_DARK = COLOR_GREY_15;
export const COLOR_LAST_VISITED_ITEM = "#d3d3d3" + TRANSPARENCY_30;
export const COLOR_TEXT_HIGHLIGHT = COLOR_YELLOW_50;

// Address position confidence (see docs/components/location-picker.md). Four bands, painted
// on the map affordance next to an address and on the pin inside the picker, so how much a
// position can be trusted is visible without opening anything.
export const COLOR_LOCATION_CONFIRMED = COLOR_GREEN_100;
export const COLOR_LOCATION_GOOD = COLOR_BLUE_100;
export const COLOR_LOCATION_POOR = COLOR_YELLOW_105;
export const COLOR_LOCATION_UNRELIABLE = COLOR_RED_100;
// Dark-mode variants: the mid-tone green and blue lose against a dark surface, so both step
// up a shade. Yellow and red already carry on dark and stay as they are.
export const COLOR_LOCATION_CONFIRMED_DARK = COLOR_GREEN_50;
export const COLOR_LOCATION_GOOD_DARK = COLOR_BLUE_80;
export const COLOR_LOCATION_POOR_DARK = COLOR_YELLOW_100;
export const COLOR_LOCATION_UNRELIABLE_DARK = COLOR_RED_100;
// A position whose address has since been edited belongs to none of the four bands: it is not
// a judgement about the address on screen, so it is painted neutrally rather than in a colour
// that would vouch for a building the user has edited away from.
export const COLOR_LOCATION_STALE = COLOR_GREY_100;
export const COLOR_LOCATION_STALE_DARK = COLOR_GREY_50;

export const COLOR_ERROR_TEXT = COLOR_STANDARD_RED;
// Pure red glares on a dark surface; this softer red also reads better there (5.9:1 on #1e1e1e vs 4.2:1).
export const COLOR_ERROR_TEXT_DARK = "#ff6961";
export const COLOR_BLACK_TEXT = COLOR_STANDARD_BLACK;
export const COLOR_WHITE_TEXT = COLOR_STANDARD_WHITE;
export const COLOR_READ_ONLY_TEXT = COLOR_STANDARD_BLACK + TRANSPARENCY_40;


export const COLOR_WHITE_BACKGROUND = COLOR_STANDARD_WHITE;
export const COLOR_SELECTED_ITEM_BACKGROUND = COLOR_GREY_15;

export const COLOR_SELECTED_NON_DEFAULT_TOOLBAR_FILTER_BACKGROUND = COLOR_STANDARD_WHITE + TRANSPARENCY_30;
export const COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND = COLOR_STANDARD_WHITE;

// Dark-mode text + background variants. Pair each with its light counterpart via
// `themed()` (src/utils/Theme.ts). Reuse these generic tokens for hardcoded
// white/light-grey surfaces and black text rather than adding one-off constants.
// High-emphasis text and active icons in dark mode: a soft off-white, since pure white glares on the
// dark background (the same shade as the dark login button). Vuetify's own dark text takes it from
// src/styles/variables.scss, which cannot import this file; tests/unit/darkTextColor.spec.ts keeps
// the two equal.
export const COLOR_TEXT_DARK = COLOR_GREY_15;
export const COLOR_BLACK_TEXT_DARK = COLOR_TEXT_DARK;
export const COLOR_READ_ONLY_TEXT_DARK = COLOR_STANDARD_WHITE + TRANSPARENCY_40;
export const COLOR_WHITE_BACKGROUND_DARK = COLOR_SURFACE_DARK;
export const COLOR_SELECTED_ITEM_BACKGROUND_DARK = COLOR_SURFACE_ELEVATED_DARK;
// The circle behind an active (non-default) filter icon in a card header, in dark mode: a raised
// circle (white at 16%) in the dark theme's own idiom, like the selected menu entry, chosen by
// Taimoor on 2026-09-29 over a light circle. #2c2c2c before matched the header card and vanished.
export const COLOR_SELECTED_NON_DEFAULT_FILTER_BACKGROUND_DARK = COLOR_STANDARD_WHITE + "29";
// Pale on purpose: the "Sicht auf" chip should be noticed, not shout (Taimoor, 2026-10-14).
export const COLOR_VIEW_AS_USER_HIGHLIGHT = "orange lighten-5";
export const COLOR_VIEW_AS_USER_HIGHLIGHT_TEXT = COLOR_BLACK_TEXT;

// ── Dark-mode status palette ────────────────────────────────────────────────
// Rule (Taimoor, 2026-09-29): in dark mode every filled surface that carries text (button, chip,
// tile, badge, labelled card) uses ONE shade per colour, and its label is always readable. The light
// theme paints these from two tiers per hue (a strong _100/_105 and a pale _50/_25, plus Vuetify
// named colours); in dark mode they all collapse onto the shade below. Light mode is unchanged.
// Resolve through `themedFill()` / `themedFillTextColor()` in src/utils/Theme.ts at render time.
// Every shade carries dark text at >= 4.5:1, except the action red, which keeps white text.
// See docs/architecture/theming.md ("Dark status palette").
export const COLOR_DARK_FILL_GREEN = "#7fae82";
export const COLOR_DARK_FILL_YELLOW = "#cfb05a";
/** Status red (on hold / overdue / missing). Actions keep the brand red, {@link COLOR_ACCENT_DARK}. */
export const COLOR_DARK_FILL_RED = "#c77b80";
export const COLOR_DARK_FILL_GREY = "#8a8a8a";
export const COLOR_DARK_FILL_ORANGE = "#cf9466";
// "Sicht auf" chip in dark mode: outlined in a clean yellow, no fill (Taimoor, 2026-10-14, chosen
// on the bar over a solid orange, a translucent and an opaque muted yellow, which read loud, green and
// dirty). Its own colour, not themedFill(): the chip carries no status.
export const COLOR_VIEW_AS_USER_HIGHLIGHT_DARK = "#f2d675";
export const COLOR_DARK_FILL_BROWN = "#b39a82";
export const COLOR_DARK_FILL_TEAL = "#5fb09a";
export const COLOR_DARK_FILL_CUSTOM_BLUE = "#6b9bb8";
export const COLOR_DARK_FILL_BLUE = "#9aaed6";
/**
 * The one hue with a second shade: project types 05 and 07 are two blues in light mode as well
 * (BLUE_25 / BLUE_50) and must stay distinguishable from each other.
 */
export const COLOR_DARK_FILL_LIGHT_BLUE = "#a9c4d8";
export const COLOR_DARK_FILL_MIDNIGHT_BLUE = "#8d8fb8";
/** Label on every dark palette shade except the action red. */
export const COLOR_DARK_FILL_TEXT = "#212121";
/** A step not started yet: an empty outlined tile rather than a fill, so it never reads as locked. */
export const COLOR_DARK_FILL_OUTLINE_BORDER = "#9e9e9e";
/** An `rgba()` rather than "transparent", which Vuetify would read as its helper class and so drop the border too. */
export const COLOR_DARK_FILL_OUTLINE_BACKGROUND = "rgba(0, 0, 0, 0)";
export const COLOR_DARK_FILL_OUTLINE_TEXT = "#e0e0e0";

/**
 * Which red a `#e6323c` fill means. The same brand red is an action on buttons (ZURÜCK, +, delete)
 * and a status on a few chips (a suspended step, an unreliable address), and only the caller knows
 * which. Every paler red is always a status.
 */
export type DarkFillRedRole = "action" | "status";

/** Light fill (lower-case hex or Vuetify colour name) → its dark palette shade. */
const DARK_FILL_BY_LIGHT_FILL: Record<string, string> = {
  [COLOR_GREEN_100]: COLOR_DARK_FILL_GREEN,
  [COLOR_GREEN_50]: COLOR_DARK_FILL_GREEN,
  [COLOR_GREEN_25]: COLOR_DARK_FILL_GREEN,
  "green": COLOR_DARK_FILL_GREEN,
  "success": COLOR_DARK_FILL_GREEN,

  [COLOR_YELLOW_105]: COLOR_DARK_FILL_YELLOW,
  [COLOR_YELLOW_100]: COLOR_DARK_FILL_YELLOW,
  [COLOR_YELLOW_50]: COLOR_DARK_FILL_YELLOW,
  "warning": COLOR_DARK_FILL_YELLOW,

  [COLOR_RED_50]: COLOR_DARK_FILL_RED,
  [COLOR_RED_25]: COLOR_DARK_FILL_RED,
  [COLOR_RED_900]: COLOR_DARK_FILL_RED,
  "red": COLOR_DARK_FILL_RED,
  "error": COLOR_DARK_FILL_RED,

  [COLOR_GREY_100]: COLOR_DARK_FILL_GREY,
  [COLOR_GREY_50]: COLOR_DARK_FILL_GREY,
  [COLOR_GREY_25]: COLOR_DARK_FILL_GREY,
  "grey": COLOR_DARK_FILL_GREY,
  "grey darken-1": COLOR_DARK_FILL_GREY,

  [COLOR_BURNT_ORANGE_50]: COLOR_DARK_FILL_ORANGE,
  [COLOR_LIGHT_ORANGE]: COLOR_DARK_FILL_ORANGE,
  "orange": COLOR_DARK_FILL_ORANGE,

  [COLOR_BROWN_50]: COLOR_DARK_FILL_BROWN,
  [COLOR_BROWN_105]: COLOR_DARK_FILL_BROWN,
  [COLOR_TEAL_50]: COLOR_DARK_FILL_TEAL,
  [COLOR_CUSTOM_BLUE_50]: COLOR_DARK_FILL_CUSTOM_BLUE,
  [COLOR_BLUE_100]: COLOR_DARK_FILL_BLUE,
  [COLOR_BLUE_50]: COLOR_DARK_FILL_BLUE,
  "#b3e0ff": COLOR_DARK_FILL_BLUE, // literal device-assignment card fill
  [COLOR_LIGHT_BLUE_GRAY]: COLOR_DARK_FILL_BLUE, // REFERENCE sensor button
  [COLOR_BLUE_25]: COLOR_DARK_FILL_LIGHT_BLUE,
  [COLOR_MIDNIGHT_BLUE_50]: COLOR_DARK_FILL_MIDNIGHT_BLUE,
};

/**
 * The dark palette shade for a light-mode fill, or `null` when the value is not a palette fill
 * (a colour the user picked, a surface colour, an empty string), which callers pass through as is.
 * Pure and theme-independent; the theme switch lives in `themedFill()`.
 */
export function darkFillFor(lightFill: string, redRole: DarkFillRedRole = "action"): string | null {
  const key = (lightFill ?? "").trim().toLowerCase();

  if (key === COLOR_RED_100) {
    return redRole === "action" ? COLOR_ACCENT_DARK : COLOR_DARK_FILL_RED;
  }

  return DARK_FILL_BY_LIGHT_FILL[key] ?? null;
}

// Header Icon & Button Colors
export const COLOR_HEADER_ICON = COLOR_ACCENT;
export const COLOR_HEADER_BUTTON = COLOR_ACCENT;

// Cockpit Colors
export const COLOR_COCKPIT_CARD_DEFAULT = COLOR_STANDARD_WHITE;
export const COLOR_COCKPIT_CARD_LIST_ITEM = COLOR_STANDARD_WHITE + TRANSPARENCY_0;

export const COLOR_COCKPIT_MANAGEMENT = COLOR_BLUE_25;
export const COLOR_COCKPIT_MY_TASKS = COLOR_YELLOW_10;
export const COLOR_COCKPIT_EXTRAS = COLOR_GREY_25;

// Dark-mode cockpit card backgrounds (tinted dark surfaces keep the categories
// distinguishable while letting the default light text stay readable).
export const COLOR_COCKPIT_CARD_DEFAULT_DARK = COLOR_SURFACE_DARK;
export const COLOR_COCKPIT_MANAGEMENT_DARK = "#1f3a52";
export const COLOR_COCKPIT_MY_TASKS_DARK = "#3a3320";
export const COLOR_COCKPIT_EXTRAS_DARK = COLOR_SURFACE_ELEVATED_DARK;

// Mira colors (docs/analytics/mira-office-screens.md)
//
// Coverage status: Mira hides a figure below 40 %, and 80 % is where coverage counts as good
// (Taimoor, 2026-09-30). Dark mode uses the desaturated *_DARK shades below for every status mark.
export const COLOR_MIRA_STATUS_GOOD = COLOR_GREEN_100;
export const COLOR_MIRA_STATUS_WARNING = COLOR_YELLOW_105;
export const COLOR_MIRA_STATUS_CRITICAL = COLOR_RED_100;
// The same statuses on the dark surface, desaturated by 20-25 % (chroma), because saturated colours
// vibrate against a dark background (Material dark theme). Not the dark status palette the chips use
// (COLOR_DARK_FILL_*): as data colours its yellow and green fall below the normal-vision floor
// (dE 11.3) and its red and grey collapse under red-green colour blindness (dE 1.5). These were found
// by search and pass the dataviz validator on #1e1e1e (2026-09-30): colour-blind dE 8.2 over all
// pairs, normal vision 17.6, contrast >= 3:1.
export const COLOR_MIRA_STATUS_GOOD_DARK = "#63a964";
export const COLOR_MIRA_STATUS_WARNING_DARK = "#e3b24a";
export const COLOR_MIRA_STATUS_CRITICAL_DARK = "#cc4545";
// The empty part of a coverage bar: a lighter step of the bar's own hue, so the state reads across
// the whole bar rather than only across the filled part.
export const COLOR_MIRA_STATUS_GOOD_TRACK = COLOR_GREEN_15;
export const COLOR_MIRA_STATUS_WARNING_TRACK = COLOR_YELLOW_15;
export const COLOR_MIRA_STATUS_CRITICAL_TRACK = COLOR_RED_15;
// In dark mode the same idea: the bar's own hue at 20 % over the dark surface. A neutral grey track
// lost the state across the empty part of the bar, which the light tracks carry.
export const COLOR_MIRA_STATUS_GOOD_TRACK_DARK = COLOR_MIRA_STATUS_GOOD_DARK + TRANSPARENCY_20;
export const COLOR_MIRA_STATUS_WARNING_TRACK_DARK = COLOR_MIRA_STATUS_WARNING_DARK + TRANSPARENCY_20;
export const COLOR_MIRA_STATUS_CRITICAL_TRACK_DARK = COLOR_MIRA_STATUS_CRITICAL_DARK + TRANSPARENCY_20;
// The status chip is a filled surface with text, so these go through themedFill() (red as "status").
export const COLOR_MIRA_STATUS_GOOD_CHIP = COLOR_GREEN_50;
export const COLOR_MIRA_STATUS_WARNING_CHIP = COLOR_YELLOW_50;
export const COLOR_MIRA_STATUS_CRITICAL_CHIP = COLOR_RED_50;
// A count with no status of its own (open work by age): one series, one hue.
export const COLOR_MIRA_BAR = COLOR_BLUE_100;
export const COLOR_MIRA_BAR_DARK = COLOR_BLUE_80;
export const COLOR_MIRA_BAR_TRACK = COLOR_BLUE_15;
export const COLOR_MIRA_BAR_TRACK_DARK = COLOR_BLUE_80 + TRANSPARENCY_20;
// A clickable Mira card in dark mode lifts to the raised surface on hover: a shadow, which is all
// the light theme needs, barely shows on the dark page.
export const COLOR_MIRA_CARD_HOVER_DARK = COLOR_SURFACE_ELEVATED_DARK;
// The HyDry device categories (Box, Mini, Panel), categorical. Validated 2026-09-30 over all pairs,
// since a dot plot can put any two side by side: light colour-blind dE 12.4, normal vision 25.7 (the
// orange is under 3:1 on white, so every mark carries its value as text); dark, found by search on
// #1e1e1e, colour-blind dE 13.3, normal vision 15.1, contrast >= 3:1.
export const COLOR_MIRA_FAMILY_BOX = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_MIRA_FAMILY_MINI = COLOR_TEAL_100;
export const COLOR_MIRA_FAMILY_PANEL = COLOR_BURNT_ORANGE_100;
export const COLOR_MIRA_FAMILY_BOX_DARK = "#4b78a5";
export const COLOR_MIRA_FAMILY_MINI_DARK = "#42a99b";
export const COLOR_MIRA_FAMILY_PANEL_DARK = "#e5743a";
// A client's own devices beside the three HyDry categories (Flottenauslastung on Geräte). Found by
// search 2026-10-01 against the three above, all pairs: light colour-blind dE 12.1, normal vision 15.3
// (closest to the midnight blue, so each bar is labelled); dark dE 13.3, normal 15.1, contrast >= 3:1.
// A purple, because red hues read as a status colour.
export const COLOR_MIRA_FAMILY_OWN = "#4c219a";
export const COLOR_MIRA_FAMILY_OWN_DARK = "#a664fe";
// The outcome mix on Geschäftsentwicklung (Abschlussarten), four categorical parts in a ring. The
// four colours validated together on 2026-10-01 for the Geräte fleets, reused because no fleet appears
// on this screen; an outcome beyond the four seen in production folds into one neutral grey part. The
// grey is the light one in both themes: the darker grey sat on the teal for colour-blind readers (light
// dE 1.0); this one passes all pairs (light 12.1 / normal 15.3, dark 10.1 / 15.1). It is under 3:1 on
// white, so the legend always prints each part's name and count beside the ring.
export const COLOR_MIRA_OUTCOME_1 = COLOR_MIRA_FAMILY_BOX;
export const COLOR_MIRA_OUTCOME_2 = COLOR_MIRA_FAMILY_MINI;
export const COLOR_MIRA_OUTCOME_3 = COLOR_MIRA_FAMILY_PANEL;
export const COLOR_MIRA_OUTCOME_4 = COLOR_MIRA_FAMILY_OWN;
export const COLOR_MIRA_OUTCOME_1_DARK = COLOR_MIRA_FAMILY_BOX_DARK;
export const COLOR_MIRA_OUTCOME_2_DARK = COLOR_MIRA_FAMILY_MINI_DARK;
export const COLOR_MIRA_OUTCOME_3_DARK = COLOR_MIRA_FAMILY_PANEL_DARK;
export const COLOR_MIRA_OUTCOME_4_DARK = COLOR_MIRA_FAMILY_OWN_DARK;
export const COLOR_MIRA_OUTCOME_OTHER = COLOR_GREY_50;
export const COLOR_MIRA_OUTCOME_OTHER_DARK = COLOR_GREY_50;
// Two-part splits on Trocknung: drying pause vs power cut, and wall / ceiling vs floor. Deliberately
// not a HyDry category colour, so no colour means two things on one screen. Validated 2026-09-30:
// light colour-blind dE 15.9, normal 18.9; dark dE 13.5, normal 16.5, contrast >= 3:1 in both.
export const COLOR_MIRA_PAUSE_DRYING = COLOR_BLUE_100;
export const COLOR_MIRA_PAUSE_DRYING_DARK = COLOR_BLUE_80;
export const COLOR_MIRA_PAUSE_POWER_CUT = COLOR_BROWN_100;
export const COLOR_MIRA_PAUSE_POWER_CUT_DARK = "#c4966a";
export const COLOR_MIRA_AREA_WALL = COLOR_BLUE_100;
export const COLOR_MIRA_AREA_WALL_DARK = COLOR_BLUE_80;
export const COLOR_MIRA_AREA_FLOOR = COLOR_BROWN_100;
export const COLOR_MIRA_AREA_FLOOR_DARK = "#c4966a";
// A change that is neither good nor bad (Trocknung, Taimoor 2026-09-30): the arrow in the text grey.
export const COLOR_MIRA_DELTA_NEUTRAL = COLOR_GREY_100;
export const COLOR_MIRA_DELTA_NEUTRAL_DARK = "#9e9e9e";
// The meter-reading states, in bar order. Checked with the dataviz palette validator on
// 2026-09-30: adjacent pairs clear colour-blind separation (worst dE 11.1) and the normal-vision
// floor (17.3) in both modes. The fourth slot differs in dark mode because midnight blue has no
// contrast on the dark surface.
export const COLOR_MIRA_ENERGY_WITH_READING = COLOR_GREEN_100;
export const COLOR_MIRA_ENERGY_UNKNOWN = COLOR_GREY_100;
export const COLOR_MIRA_ENERGY_INVALID = COLOR_RED_100;
export const COLOR_MIRA_ENERGY_IMPLAUSIBLE = COLOR_MIDNIGHT_BLUE_100;
// Dark mode: the desaturated status shades, and a neutral grey searched to pass beside them
// (colour-blind dE 8.6, normal vision 15.7, contrast >= 3:1 on #1e1e1e).
export const COLOR_MIRA_ENERGY_WITH_READING_DARK = COLOR_MIRA_STATUS_GOOD_DARK;
export const COLOR_MIRA_ENERGY_UNKNOWN_DARK = "#787878";
export const COLOR_MIRA_ENERGY_INVALID_DARK = COLOR_MIRA_STATUS_CRITICAL_DARK;
export const COLOR_MIRA_ENERGY_IMPLAUSIBLE_DARK = COLOR_BLUE_80;

// The Verlauf (timeline) chart and the percentile marks. The line is neutral, the one Mira blue the
// bars use, because a rise over time is neither good nor bad. The P15 to P85 band and range reuse the
// bar track, a quiet step of the same hue, so the spread reads as a quieter version of the line.
export const COLOR_MIRA_TREND_LINE = COLOR_MIRA_BAR;
export const COLOR_MIRA_TREND_LINE_DARK = COLOR_MIRA_BAR_DARK;
export const COLOR_MIRA_TREND_BAND = COLOR_MIRA_BAR_TRACK;
export const COLOR_MIRA_TREND_BAND_DARK = COLOR_MIRA_BAR_TRACK_DARK;
// The band as the chart fills it: see-through, so the chosen period's shading (drawn underneath) shows.
export const COLOR_MIRA_TREND_BAND_FILL = COLOR_MIRA_BAR_TRACK + TRANSPARENCY_70;
// Built on the plain blue: the dark track already ends in an alpha suffix, and a second one made an
// invalid ten-digit colour that Chart.js painted black (2026-10-02).
export const COLOR_MIRA_TREND_BAND_FILL_DARK = COLOR_BLUE_80 + TRANSPARENCY_25;
// The median as a thin line inside the band (H2, Hans 2026-10-05): a lighter step of the Mira blue, so
// it reads as secondary to the mean line above it and stays visible on the band and on the dark surface.
export const COLOR_MIRA_TREND_MEDIAN = COLOR_BLUE_65;
export const COLOR_MIRA_TREND_MEDIAN_DARK = COLOR_BLUE_45;
// The chosen period on the Verlauf history: the period header's own grey, so the two read as one.
export const COLOR_MIRA_TREND_PERIOD = COLOR_TABLE_HEADER;
export const COLOR_MIRA_TREND_PERIOD_DARK = COLOR_TABLE_HEADER_DARK;
// The outline a selectable tile takes when it is the figure the Verlauf card is showing.
export const COLOR_MIRA_TILE_SELECTED = COLOR_MIRA_BAR;
export const COLOR_MIRA_TILE_SELECTED_DARK = COLOR_MIRA_BAR_DARK;

// The "Markt" comparison scale (#2610009 C4): the company's own value against the market's P15-P85 band
// and median on one horizontal scale. A neutral grey track carries the whole range; the band is a pale
// blue step over it, so it reads as the market's spread; the median is the trend's own median blue; the
// own value is the strong Mira bar blue, the most salient mark, as "dein Wert" is on every comparison.
// One hue family (blue intensities on grey) keeps "your place in the market spread" reading as one idea,
// with the marks told apart by weight, a diamond on the own value, and their labels.
export const COLOR_MIRA_MARKET_TRACK = COLOR_GREY_15;
export const COLOR_MIRA_MARKET_TRACK_DARK = COLOR_DARK_FILL_GREY + TRANSPARENCY_20;
export const COLOR_MIRA_MARKET_BAND = COLOR_BLUE_25;
export const COLOR_MIRA_MARKET_BAND_DARK = COLOR_BLUE_80 + TRANSPARENCY_40;
export const COLOR_MIRA_MARKET_MEDIAN = COLOR_MIRA_TREND_MEDIAN;
export const COLOR_MIRA_MARKET_MEDIAN_DARK = COLOR_MIRA_TREND_MEDIAN_DARK;
/** The Markt's bars and dot in a comparison: a neutral mid grey, so the market reads as the backdrop (Hans, #2610137). */
export const COLOR_MIRA_MARKET_BAR = COLOR_GREY_50;
export const COLOR_MIRA_MARKET_BAR_DARK = COLOR_GREY_100;
/** The gesamt bar of an average compared across branches / members (#2610137): grey like the Markt, darker. */
export const COLOR_MIRA_REFERENCE_BAR = COLOR_GREY_100;
export const COLOR_MIRA_REFERENCE_BAR_DARK = COLOR_GREY_50;
/** The Versicherer card's case bar (#2610137): with an insurer, no information, direct order. */
export const COLOR_MIRA_INSURANCE_INSURED = COLOR_MIRA_OUTCOME_1;
export const COLOR_MIRA_INSURANCE_NO_INFO = COLOR_MIRA_OUTCOME_OTHER;
export const COLOR_MIRA_INSURANCE_DIRECT = COLOR_MIRA_OUTCOME_2;
export const COLOR_MIRA_INSURANCE_INSURED_DARK = COLOR_MIRA_OUTCOME_1_DARK;
export const COLOR_MIRA_INSURANCE_NO_INFO_DARK = COLOR_MIRA_OUTCOME_OTHER_DARK;
export const COLOR_MIRA_INSURANCE_DIRECT_DARK = COLOR_MIRA_OUTCOME_2_DARK;
/** The Geräte je Projekt tile's share bar (#2610137): Box, Mini, both, neither. */
export const COLOR_MIRA_CONTROL_BOX = COLOR_MIRA_FAMILY_BOX;
export const COLOR_MIRA_CONTROL_MINI = COLOR_MIRA_FAMILY_MINI;
export const COLOR_MIRA_CONTROL_BOTH = COLOR_BLUE_65;
export const COLOR_MIRA_CONTROL_NONE = COLOR_GREY_25;
export const COLOR_MIRA_CONTROL_BOX_DARK = COLOR_MIRA_FAMILY_BOX_DARK;
export const COLOR_MIRA_CONTROL_MINI_DARK = COLOR_MIRA_FAMILY_MINI_DARK;
export const COLOR_MIRA_CONTROL_BOTH_DARK = COLOR_BLUE_45;
export const COLOR_MIRA_CONTROL_NONE_DARK = COLOR_GREY_100;
export const COLOR_MIRA_MARKET_OWN = COLOR_MIRA_BAR;
export const COLOR_MIRA_MARKET_OWN_DARK = COLOR_MIRA_BAR_DARK;

// The Rangliste's markers (Hans, #2610040 R3): the reference's P15 / median / P85 as thin lines across
// every row's track. Dark navy in light mode and white in dark mode, so a line reads over the filled bar
// as well as over the empty track.
export const COLOR_MIRA_COMPARISON_MARKER = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_MIRA_COMPARISON_MARKER_DARK = COLOR_STANDARD_WHITE;

/*
 * The comparison's categorical series: one stable colour per company / branch, assigned once by the
 * entity's size (its projects in the chosen period), largest first. The eight largest entities get
 * slots 1..8; every other entity shares `…_REST` (a neutral grey) and keeps its identity in the legend
 * and tooltip (Taimoor, 2026-10-06, after the browser review: a company's colour must follow the
 * company, not its rank within one figure). Each figure still draws only the five relevant bars, each
 * in ITS stable colour, side by side (a grouped, not stacked, bar chart). The base purple
 * (`COLOR_MIRA_FAMILY_OWN`) is too dark for a bar, so the lighter `…_OWN_DARK` shade stands in for it.
 *
 * Eight mutually distinguishable categorical hues is beyond what colour-vision-deficient separation
 * allows (true of every 8-colour categorical set, the dataviz reference palette included), so these are
 * the best achievable and lean on the always-present legend, the per-bar tooltip and the stable (so
 * learnable) colour as the secondary encoding the method requires, with only five bars shown at once.
 * Dataviz validator, 2026-10-06, worst pair across ALL pairs (any two may stand side by side):
 *   - light (surface #ffffff): CVD ΔE 2.3 (brown ↔ red, deutan), normal-vision ΔE 11.1 (blue ↔ teal);
 *   - dark (surface #1e1e1e): CVD ΔE 4.9 and normal-vision ΔE 6.7 (both green ↔ teal).
 * The grey `…_REST` is a deliberate neutral, not a ninth hue.
 */
export const COLOR_MIRA_SERIES_1 = COLOR_BLUE_100;
export const COLOR_MIRA_SERIES_2 = COLOR_BURNT_ORANGE_100;
export const COLOR_MIRA_SERIES_3 = COLOR_TEAL_100;
export const COLOR_MIRA_SERIES_4 = COLOR_MIRA_FAMILY_OWN_DARK;
export const COLOR_MIRA_SERIES_5 = COLOR_RED_100;
export const COLOR_MIRA_SERIES_6 = COLOR_GREEN_100;
export const COLOR_MIRA_SERIES_7 = COLOR_BROWN_100;
export const COLOR_MIRA_SERIES_8 = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_MIRA_SERIES_REST = COLOR_GREY_100;
export const COLOR_MIRA_SERIES_1_DARK = COLOR_BLUE_80;
export const COLOR_MIRA_SERIES_2_DARK = COLOR_MIRA_FAMILY_PANEL_DARK;
export const COLOR_MIRA_SERIES_3_DARK = COLOR_MIRA_FAMILY_MINI_DARK;
export const COLOR_MIRA_SERIES_4_DARK = COLOR_MIRA_FAMILY_OWN_DARK;
export const COLOR_MIRA_SERIES_5_DARK = COLOR_RED_100;
export const COLOR_MIRA_SERIES_6_DARK = COLOR_DARK_FILL_GREEN;
export const COLOR_MIRA_SERIES_7_DARK = COLOR_DARK_FILL_YELLOW;
export const COLOR_MIRA_SERIES_8_DARK = COLOR_MIRA_FAMILY_BOX_DARK;
export const COLOR_MIRA_SERIES_REST_DARK = COLOR_DARK_FILL_GREY;

/*
 * The five levels a comparison of more than eight entities draws instead of naming each one (Hans,
 * #2610112 option B): Best (or Höchster), 25 %, 50 %, 75 %, Worst (or Niedrigster). An ordered scale, so
 * one hue stepping from strong to light rather than five categories: the levels are positions in one
 * distribution, not peers. Dark mode reverses the steps, so the first level stays the most prominent
 * against the dark surface.
 */
export const COLOR_MIRA_LEVEL_1 = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_MIRA_LEVEL_2 = COLOR_BLUE_100;
export const COLOR_MIRA_LEVEL_3 = COLOR_BLUE_80;
export const COLOR_MIRA_LEVEL_4 = COLOR_BLUE_65;
export const COLOR_MIRA_LEVEL_5 = COLOR_BLUE_45;
export const COLOR_MIRA_LEVEL_1_DARK = COLOR_BLUE_25;
export const COLOR_MIRA_LEVEL_2_DARK = COLOR_BLUE_45;
export const COLOR_MIRA_LEVEL_3_DARK = COLOR_BLUE_65;
export const COLOR_MIRA_LEVEL_4_DARK = COLOR_BLUE_80;
export const COLOR_MIRA_LEVEL_5_DARK = COLOR_BLUE_100;

/*
 * Projektablauf stacked bars (Prozess, MIRA-PHA-011): the four project stages, in the hues the project
 * list badges use for those states, strengthened to the full tint so a segment reads on the surface
 * (the pale badge tints wash out as fills). Theme-invariant, like the badges themselves. Validated
 * 2026-10-05: worst adjacent (Trocknung blue ↔ Projektende grey) ΔE 8.2 CVD / 9.4 normal, the two blues
 * (Trocknungsaufbau ↔ Trocknung) clearly apart; the 2px gap and the legend carry the identity.
 * `_SETUP` / `_DRYING` are the "nearest validated pair" for the badge blues (_06 / _07), whose pale
 * tints failed adjacency. Validated 2026-10-05 (dataviz), every adjacent pair ΔE >= 8 for CVD in both
 * modes: Schadenaufnahme ↔ Trocknungsaufbau 13.5 (protan), Trocknungsaufbau ↔ Trocknung 9.2, Trocknung ↔
 * Projektende 8.2.
 */
export const COLOR_MIRA_STAGE_ASSESSMENT = COLOR_BROWN_100;
export const COLOR_MIRA_STAGE_SETUP = COLOR_CUSTOM_BLUE_100;
export const COLOR_MIRA_STAGE_DRYING = COLOR_BLUE_100;
export const COLOR_MIRA_STAGE_END = COLOR_GREY_100;
export const COLOR_MIRA_STAGE_ASSESSMENT_DARK = COLOR_BROWN_100;
export const COLOR_MIRA_STAGE_SETUP_DARK = COLOR_CUSTOM_BLUE_100;
export const COLOR_MIRA_STAGE_DRYING_DARK = COLOR_BLUE_100;
export const COLOR_MIRA_STAGE_END_DARK = COLOR_GREY_100;

/*
 * Leistungen stacked bars (Geschäftsentwicklung, MIRA-PRJ-017): the four services, in the project list
 * badge hues (Leckortung, Schadenaufnahme brown, Trocknung blue, Wiederherstellung dark blue),
 * strengthened to full tint as fills. The darkest (Wiederherstellung) is lightened for the dark surface
 * so it keeps contrast there. Leckortung uses the amber (yellower) end of the orange family rather than
 * the burnt orange: Leckortung as a service is common (it is counted inside flex projects, not the dead
 * standalone leak projects), so it is adjacent to Schadenaufnahme brown on every bar and must separate on
 * its own, not on the gap or the legend. Schadenaufnahme is the same brown as on the stage palette, so the
 * step reads identically on Prozess and Geschäftsentwicklung. Validated 2026-10-05 (dataviz), every
 * adjacent pair ΔE >= 8 for CVD in both modes: Leckortung amber ↔ Schadenaufnahme brown 20.5 (protan),
 * brown ↔ Trocknung 13.5, Trocknung ↔ Wiederherstellung 12.8 (light) / 18.3 (dark).
 */
export const COLOR_MIRA_SERVICE_LEAK = COLOR_YELLOW_105;
export const COLOR_MIRA_SERVICE_ASSESSMENT = COLOR_BROWN_100;
export const COLOR_MIRA_SERVICE_DRYING = COLOR_CUSTOM_BLUE_100;
export const COLOR_MIRA_SERVICE_REPAIR = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_MIRA_SERVICE_LEAK_DARK = COLOR_YELLOW_105;
export const COLOR_MIRA_SERVICE_ASSESSMENT_DARK = COLOR_BROWN_100;
export const COLOR_MIRA_SERVICE_DRYING_DARK = COLOR_CUSTOM_BLUE_100;
export const COLOR_MIRA_SERVICE_REPAIR_DARK = COLOR_MIDNIGHT_BLUE_50;

// Projects Overview Colors
/* export const COLOR_PROJECT_TYPE_STATE_01 = COLOR_YELLOW_100;
export const COLOR_PROJECT_TYPE_STATE_02 = COLOR_BURNT_ORANGE_100;
export const COLOR_PROJECT_TYPE_STATE_03 = COLOR_BROWN_100;
export const COLOR_PROJECT_TYPE_STATE_04 = COLOR_TEAL_100;
export const COLOR_PROJECT_TYPE_STATE_05 = COLOR_BLUE_50;
export const COLOR_PROJECT_TYPE_STATE_06 = COLOR_CUSTOM_BLUE_100;
export const COLOR_PROJECT_TYPE_STATE_07 = COLOR_BLUE_100;
export const COLOR_PROJECT_TYPE_STATE_08 = COLOR_MIDNIGHT_BLUE_100;
export const COLOR_PROJECT_TYPE_STATE_09 = COLOR_GREY_50; */

export const COLOR_PROJECT_TYPE_STATE_01 = COLOR_YELLOW_50;
export const COLOR_PROJECT_TYPE_STATE_02 = COLOR_BURNT_ORANGE_50;
export const COLOR_PROJECT_TYPE_STATE_03 = COLOR_BROWN_50;
export const COLOR_PROJECT_TYPE_STATE_04 = COLOR_TEAL_50;
export const COLOR_PROJECT_TYPE_STATE_05 = COLOR_BLUE_25;
export const COLOR_PROJECT_TYPE_STATE_06 = COLOR_CUSTOM_BLUE_50;
export const COLOR_PROJECT_TYPE_STATE_07 = COLOR_BLUE_50;
export const COLOR_PROJECT_TYPE_STATE_08 = COLOR_MIDNIGHT_BLUE_50;
export const COLOR_PROJECT_TYPE_STATE_09 = COLOR_GREY_25;

export const COLOR_APPOINTMENT_LEAK_DETECTION = COLOR_BROWN_50;
export const COLOR_APPOINTMENT_DAMAGE_ASSESSMENT = COLOR_BURNT_ORANGE_50;
export const COLOR_APPOINTMENT_DRYING_PREPARATION = COLOR_CUSTOM_BLUE_50;
export const COLOR_APPOINTMENT_INTERMEDIATE_MEASUREMENT = COLOR_BLUE_50;
export const COLOR_APPOINTMENT_DRYING_CONCLUSION = COLOR_BLUE_50;
export const COLOR_APPOINTMENT_REPAIR = COLOR_MIDNIGHT_BLUE_50;
export const COLOR_APPOINTMENT_FOLLOW_UP = COLOR_GREY_25
export const COLOR_APPOINTMENT_DEFAULT = COLOR_BROWN_50

export const COLOR_PROJECT_TILE_COMPLETE = COLOR_GREEN_50;
export const COLOR_PROJECT_TILE_INCOMPLETE = COLOR_YELLOW_50;
export const COLOR_PROJECT_TILE_ON_HOLD = COLOR_RED_50;
export const COLOR_PROJECT_TILE_LOCKED = COLOR_GREY_50;

export const COLOR_DRYING_PROGRESS_BAR_GREEN = COLOR_GREEN_50;
export const COLOR_DRYING_PROGRESS_BAR_YELLOW = COLOR_YELLOW_50;
export const COLOR_DRYING_PROGRESS_BAR_RED = COLOR_RED_50;
export const COLOR_DRYING_PROGRESS_BAR_GREY = COLOR_GREY_25;
// The empty track is drawn at full opacity, so the pale light-mode grey glares on a dark row.
export const COLOR_DRYING_PROGRESS_BAR_GREY_DARK = "#424242";

export const COLOR_INFO_TEXT_GREEN = COLOR_GREEN_100;
export const COLOR_INFO_TEXT_RED = COLOR_RED_100;
export const COLOR_INFO_TEXT_APPOINTMENT_BACKGROUND = COLOR_RED_100;

export const COLOR_HY_DRY_DEVICE_ASSIGNMENT_LINK = COLOR_BUTTON_LINK;
export const COLOR_HY_DRY_DEVICE_ASSIGNMENT_LINK_ACTION = COLOR_BUTTON_LINK_ACTION;

export const COLOR_PROJECT_TYPE_RUNNING = COLOR_YELLOW_105;
export const COLOR_PROJECT_TYPE_FINISHED = COLOR_GREEN_100;
export const COLOR_PROJECT_TYPE_ARCHIVED = COLOR_GREY_25;
export const COLOR_PROJECT_TYPE_DELETED = COLOR_STANDARD_BLACK;

// Project Detail Colors
export const COLOR_PROJECT_DETAILS_SELECTED_TAB = COLOR_PRIMARY;

export const COLOR_PROJECT_STEP_BUTTON_COMPLETE = COLOR_GREEN_50;
export const COLOR_PROJECT_STEP_BUTTON_INCOMPLETE = COLOR_YELLOW_50;
export const COLOR_PROJECT_STEP_BUTTON_OVERDUE = COLOR_RED_50;
export const COLOR_PROJECT_STEP_BUTTON_REPORT = COLOR_GREY_50;

export const COLOR_PROJECT_TIMELINE_STEP_DONE = COLOR_GREEN_100;
export const COLOR_PROJECT_TIMELINE_STEP_OPEN = COLOR_YELLOW_105;
export const COLOR_PROJECT_TIMELINE_STEP_APPOINTMENT_INFO_MISSING = COLOR_YELLOW_105;
export const COLOR_PROJECT_TIMELINE_STEP_APPIONTMENT_PENDING = COLOR_RED_100;
export const COLOR_PROJECT_TIMELINE_STEP_SUSPENDED = COLOR_RED_100;
export const COLOR_PROJECT_TIMELINE_STEP_LOCKED = COLOR_GREY_100;
export const COLOR_PROJECT_TIMELINE_STEP_DEFAULT = COLOR_GREY_100;

export const COLOR_SELECTED_QUALITY_RATING = COLOR_YELLOW_50;
export const COLOR_NOT_SELECTED_QUALITY_RATING = COLOR_GREY_25;
/**
 * Unselected rating cell in dark mode.
 *
 * The light-mode grey is a pale fill that reads with dark text; in the dark theme the button label
 * turns white and disappears into it. An elevated dark surface keeps the cell visible as a button
 * while letting the default white label stay legible. The *selected* colour stays the same yellow in
 * both themes, since it is the app-wide "this one is chosen" signal, but its label must be forced
 * dark.
 */
export const COLOR_NOT_SELECTED_QUALITY_RATING_DARK = COLOR_SURFACE_ELEVATED_DARK;

/**
 * The 1-4 quality scale as four distinct fills, worst to best.
 *
 * Used where the four steps are separate buttons that each perform an action, rather than one
 * segmented control whose chosen cell is highlighted — there, {@link COLOR_SELECTED_QUALITY_RATING}
 * still applies. Only a selected step is filled; the others stay grey.
 *
 * Deliberately the **same colour family as the AI-prediction quality score** — the ramp behind
 * {@link COLOR_AI_PREDICTION_CRITICAL} / {@link COLOR_AI_PREDICTION_NEEDS_REVIEW} /
 * {@link COLOR_AI_PREDICTION_GOOD} — because a reviewer grading a prediction is grading that score,
 * and two different reds-to-greens for the same judgement read as two different meanings. Those three
 * constants cannot be referenced from here (they are declared further down the file, so it would be a
 * use-before-define), hence the shared base values instead.
 *
 * It follows the family rather than sampling the ramp at four points, which deviates in two places:
 *
 * - `VERY_BAD` is the **deep** red, not the ramp's `COLOR_RED_100` — that value *is*
 *   {@link COLOR_ACCENT}, so the worst grade came out pixel-identical to every primary action button
 *   next to it and pressing SCHLECHT looked like pressing Weiter. It also stays clear of
 *   {@link COLOR_ACCENT_DARK} (`#c62f38`), the accent in the dark theme.
 * - `GOOD` is the pale green, where the ramp two-thirds along is a yellow-green. Four steps need the
 *   pair either side of the middle to differ in hue, and a lesser green reads as a lesser green;
 *   sampling the ramp instead puts an orange at `BAD`, which is not a step on this scale.
 */
export const COLOR_QUALITY_RATING_VERY_BAD = COLOR_RED_900;
export const COLOR_QUALITY_RATING_BAD = COLOR_YELLOW_105;
export const COLOR_QUALITY_RATING_GOOD = COLOR_GREEN_50;
export const COLOR_QUALITY_RATING_VERY_GOOD = COLOR_GREEN_100;

/** The four fills in scale order, so a 1-4 rating indexes straight into it. */
export const COLORS_QUALITY_RATING_SCALE = [
  COLOR_QUALITY_RATING_VERY_BAD,
  COLOR_QUALITY_RATING_BAD,
  COLOR_QUALITY_RATING_GOOD,
  COLOR_QUALITY_RATING_VERY_GOOD,
];

/**
 * The Vuetify text class each scale fill needs for a legible label.
 *
 * Vuetify does not pick a label colour for an arbitrary hex: it leaves the theme default, which is
 * near-black in light mode and white in dark mode. So on a coloured button the label has to be forced,
 * or the same fill reads well in one theme and disappears in the other.
 *
 * Paired per colour rather than computed, because a luminance threshold gets the two greens wrong: the
 * mid green is light enough that arithmetic prefers dark text on it, and it does not read that way.
 */
export const TEXT_CLASSES_QUALITY_RATING_SCALE = [
  "white--text", // deep red
  "black--text", // yellow
  "black--text", // pale green
  "white--text", // green
];

/**
 * "Good" on the dark 1-4 scale: a lime between the scale's yellow and green.
 *
 * The one colour outside the dark status palette (see "Dark-mode status palette"), and only for this
 * scale: the palette has a single green, and the ramp needs "good" and "very good" told apart at a
 * glance (decision made on 2026-09-29, Taimoor). ΔE 24 from the yellow, 29 from the green; dark text 8:1.
 */
export const COLOR_QUALITY_RATING_GOOD_DARK = "#a8c060";

/** {@link COLORS_QUALITY_RATING_SCALE} for the dark theme: palette shades, plus the lime for "good". */
export const COLORS_QUALITY_RATING_SCALE_DARK = [
  COLOR_DARK_FILL_RED,
  COLOR_DARK_FILL_YELLOW,
  COLOR_QUALITY_RATING_GOOD_DARK,
  COLOR_DARK_FILL_GREEN,
];

/** Every dark-scale fill carries dark text. Index-paired with {@link COLORS_QUALITY_RATING_SCALE_DARK}. */
export const TEXT_CLASSES_QUALITY_RATING_SCALE_DARK = [
  "black--text",
  "black--text",
  "black--text",
  "black--text",
];

/** A reviewer's "this program chain itself looks wrong" marker. Not a quality judgement. */
export const COLOR_CHAIN_SUSPECT = COLOR_RED_100;

/**
 * A reviewer's "never show me this drying again" marker. Not a quality judgement either.
 *
 * Deliberately grey rather than a second warning colour: hiding a drying is a preference about the
 * reviewer's own queue, and a red would read as a second complaint beside the chain report.
 */
export const COLOR_SUPPRESSED = COLOR_GREY_100;

export const COLOR_DOWNLOAD_FILE_BUTTON_ICON = COLOR_GREY_100;

// HyDry Devices Overview Colors
export const COLOR_PROJECT_ASSIGNMENT_LINK = COLOR_GREEN_25;
export const COLOR_PROJECT_DEVICE_ASSIGNMENT_LINK_ACTION = COLOR_BUTTON_LINK_ACTION;
export const COLOR_LAST_PROJECT_DEVICE_ASSIGNMENT_LINK = COLOR_GREY_25;

// HyDry Device Colors
export const COLOR_HY_DRY_STATUS_IDLE = COLOR_GREEN_100;
export const COLOR_HY_DRY_STATUS_ACTIVE = COLOR_BLUE_100;
export const COLOR_HY_DRY_STATUS_INACTIVE = COLOR_GREY_25;
export const COLOR_HY_DRY_STATUS_WARNING = COLOR_YELLOW_105;
export const COLOR_HY_DRY_STATUS_ERROR = COLOR_RED_100;

// All Devices Colors
export const COLOR_ALL_DEVICES_EDIT_ICON = COLOR_PRIMARY;
export const COLOR_ALL_DEVICES_DELETE_ICON = COLOR_PRIMARY;
export const COLOR_ALL_DEVICES_FOLDER_ICON = COLOR_PRIMARY;
export const COLOR_ALL_DEVICES_SETTINGS_ICON = COLOR_PRIMARY;

export const COLOR_ALL_DEVICES_PROJECT_LINK = COLOR_GREEN_50;

// Drying Graph Colors
export const COLOR_DRYING_GRAPH_LEGEND_BACKGROUND = COLOR_GREY_25;
export const COLOR_DRYING_GRAPH_LEGEND_BACKGROUND_DARK = COLOR_SURFACE_ELEVATED_DARK;
// The legend's header buttons in dark mode: a step above the legend card so they still read as
// buttons. Not a palette grey, because their text colours carry the sensor usage (green / yellow),
// which a mid grey cannot keep readable; white is 10:1 here, the pale green 6.2:1.
export const COLOR_DRYING_GRAPH_LEGEND_HEADER_DARK = "#424242";

export const COLOR_GRAPH_DARK_RED = COLOR_RED_100;
export const COLOR_GRAPH_LIGHT_RED = "#ff6961" + TRANSPARENCY_75;

export const COLOR_GRAPH_DARK_BLUE = COLOR_CUSTOM_BLUE_100;
export const COLOR_GRAPH_LIGHT_BLUE = "#03a9f4";

// ── Timeline event-track colors (RenoTimeSeries) ───────────────────────────
// Each track has a distinct, meaning-based color; model confidence is encoded
// via line weight/opacity, not color. The rows are visually grouped by spacing
// (drying state · slow-drying causes · room climate · device faults · hint) — the
// color carries the label's meaning, not the group. Adjacent tracks are validated
// for colorblind separation and all colors meet ≥ 3:1 contrast on the light chart
// surface. EDT and raumtrocknung never share a strip (they share only
// powerOutage), so each program's rows are validated as their own set.
// Resolver + confidence styling: src/utils/timelineTrackStyle.ts.
export const COLOR_TRACK_DRY = "#15803d"; // Trocken — material dry (good) → green
export const COLOR_TRACK_STATIONARY = "#64748b"; // Stationär — no progress → neutral slate
export const COLOR_TRACK_MOISTURE = "#2563eb"; // Neue Feuchte — new humidity → blue
export const COLOR_TRACK_SLOW_DRYING = "#d97706"; // Langsam — drying too slow → amber
export const COLOR_TRACK_AMBIENT = "#0891a5"; // Klima — unfavorable ambient → cyan
export const COLOR_TRACK_AIRFLOW = "#c026d3"; // Strömung — low airflow → fuchsia
export const COLOR_TRACK_PERIPHERAL_MOISTURE = "#0d9488"; // Feuchte in Peripherie → teal
export const COLOR_TRACK_POWER_OUTAGE = "#dc2626"; // Stromausfälle — power alert → red
export const COLOR_TRACK_RELAY_DEFECT = "#9333ea"; // Relais — hardware fault → purple
// Raumtrocknung rows, validated 2026-10-02 in lane order with powerOutage (dataviz
// palette validator, adjacent pairs: colourblind dE >= 8.6, normal vision >= 18.2).
export const COLOR_TRACK_ROOM_TEMPERATURE = "#ea580c"; // Temperatur → orange, echoing the graph's temperature
export const COLOR_TRACK_ROOM_HUMIDITY = "#0891b2"; // rel. Feuchte → cyan, near the graph's teal humidity
export const COLOR_TRACK_MOISTURE_LOAD = "#4f46e5"; // abs. Feuchte (g/kg) → indigo
export const COLOR_TRACK_DEVICE_OUTPUT = "#a21caf"; // Leistung — device output abnormal → fuchsia
// A hint, not a fault: a calm hue, never red or orange.
export const COLOR_TRACK_FAVORABLE_WEATHER = "#059669"; // Lüften — ventilating would help → emerald

export const COLOR_DRYING_GRAPH_TEMP_ROOM_SENSOR = COLOR_BURNT_ORANGE_100;
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_1 = COLOR_RED_100;
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_2 = "#d6213f";
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_3 = "#c40e41";
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_4 = "#b10042";
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_5 = "#9d0042";
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_6 = "#8a0040";
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_7 = "#76003d";
export const COLOR_DRYING_GRAPH_TEMP_FLOOR_SENSOR_8 = "#620038";

export const COLOR_DRYING_GRAPH_TEMP_PANEL_GROUND = "#d2691e";
export const COLOR_DRYING_GRAPH_TEMP_PANEL_WALL = "#e60000";

export const COLOR_DRYING_GRAPH_TEMP_DEFAULT = COLOR_STANDARD_BLACK;

export const COLOR_DRYING_GRAPH_HUMIDITY_ROOM_SENSOR = COLOR_TEAL_100;
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_1 = COLOR_CUSTOM_BLUE_100;
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_2 = "#006493";
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_3 = "#00599d";
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_4 = "#004fa3";
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_5 = "#0043a6";
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_6 = "#0036a4";
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_7 = "#0028a0";
export const COLOR_DRYING_GRAPH_HUMIDITY_FLOOR_SENSOR_8 = "#06138a";

export const COLOR_DRYING_GRAPH_HUMIDITY_DEFAULT = COLOR_STANDARD_BLACK;

export const COLOR_DRYING_GRAPH_RESISTANCE_ROOM_SENSOR = "#00ffcc";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_1 = "#ff00ff";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_2 = "#e100eb";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_3 = "#c400d7";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_4 = "#a800c4";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_5 = "#8d00b1";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_6 = "#73009e";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_7 = "#5a008c";
export const COLOR_DRYING_GRAPH_RESISTANCE_FLOOR_SENSOR_8 = "#42007a";

export const COLOR_DRYING_GRAPH_RESISTANCE_DEFAULT = COLOR_STANDARD_BLACK;

export const COLOR_DRYING_GRAPH_INTENSITY = "#008e81";

export const COLOR_DRYING_GRAPH_TEMP_WEATHER = COLOR_DRYING_GRAPH_TEMP_ROOM_SENSOR;
export const COLOR_DRYING_GRAPH_HUMIDITY_WEATHER = COLOR_DRYING_GRAPH_HUMIDITY_ROOM_SENSOR;
export const COLOR_DRYING_GRAPH_PRESSURE_WEATHER = "#aa00ff";
export const COLOR_DRYING_GRAPH_PERCIPITATION_WEATHER = "#00f7ff";
export const COLOR_DRYING_GRAPH_PRECIPITATION_FILL = "#00f7ff" + TRANSPARENCY_25;

export const COLOR_DRYING_GRAPH_POWER_CONSUMPTION = "#ffae42";

export const COLOR_DRYING_GRAPH_RUN_START = "#4ecca3";
export const COLOR_DRYING_GRAPH_RUN_END = "#ff2e00";

export const COLOR_DRYING_GRAPH_MIN_MAX_FILL_COLOR_WALL = "#ff2e00" + TRANSPARENCY_40;
export const COLOR_DRYING_GRAPH_MIN_MAX_FILL_COLOR_OTHER = "#ff6961" + TRANSPARENCY_25;

// Intensity-tinted panel temperature band (Office only): the min/max fill keeps
// these fixed hues, but its alpha is driven by drying intensity (heatRatio %) so
// the band fades as the wall dries (lower intensity = drier = fainter).
// See docs/devices/drying-graph-and-legend.md.
export const COLOR_DRYING_GRAPH_MIN_MAX_FILL_HUE_WALL = "#ff2e00";
export const COLOR_DRYING_GRAPH_MIN_MAX_FILL_HUE_OTHER = "#ff6961";

// Intensity (heatRatio %) window mapped across the fill's opacity range. Panel
// runs operate in a narrow low band, so mapping the full 0-100 % scale makes the
// tint nearly flat; this window amplifies the real variation into a visible fade.
// intensity <= DRY -> min alpha (driest); >= WET -> max alpha (wettest). Tune to
// match the real operating range.
export const DRYING_GRAPH_FILL_INTENSITY_DRY = 20;
export const DRYING_GRAPH_FILL_INTENSITY_WET = 70;

// Opacity range per band (dry -> wet). Wide range = prominent fade. Both bands
// currently share one range so the fade reads the same across wall and ground.
export const DRYING_GRAPH_FILL_ALPHA_MIN_WALL = 0.08;
export const DRYING_GRAPH_FILL_ALPHA_MAX_WALL = 0.9;
export const DRYING_GRAPH_FILL_ALPHA_MIN_OTHER = 0.08;
export const DRYING_GRAPH_FILL_ALPHA_MAX_OTHER = 0.9;

// Alpha applied to non-highlighted drying-graph datasets while the user hovers a
// sensor (line/legend). Shared by the line dim (globalAlpha in the highlight
// plugin) and the band-fill dim (baked into the fill gradient's stop alphas) so
// lines and fill fade in step. See DryingProgressGraph.vue / the extractor.
export const DRYING_GRAPH_HIGHLIGHT_DIM_ALPHA = 0.08;

/**
 * Appends an 8-bit alpha channel to a `#rrggbb` hex color, producing `#rrggbbaa`.
 * `alpha` is a 0..1 fraction (clamped); mirrors the `TRANSPARENCY_*` suffixes but
 * for runtime-computed opacities (e.g. the intensity-driven drying-band fill).
 */
export function hexWithAlpha(hex: string, alpha: number): string {
  const clampedAlpha = Math.min(1, Math.max(0, alpha));
  const alphaByte = Math.round(clampedAlpha * 255);
  return hex + alphaByte.toString(16).padStart(2, "0");
}

export const COLOR_DRYING_GRAPH_TRANSPARENT_BLACK = COLOR_STANDARD_BLACK + TRANSPARENCY_0;
export const COLOR_DRYING_GRAPH_TRANSPARENT_WHITE = COLOR_STANDARD_WHITE + TRANSPARENCY_0;

export const COLOR_DRYING_GRAPH_REGION_POWER_FAIL = COLOR_RED_15 + TRANSPARENCY_70;
export const COLOR_DRYING_GRAPH_REGION_DRYING_PAUSE = COLOR_BLUE_25 + TRANSPARENCY_50;
// Dark-mode region fills: lighter, more opaque bands stay visible on the dark
// graph while keeping the black region label readable.
// Subtle tints: low-opacity fills read as gentle bands on the dark plot instead
// of popping out (high-opacity fills were too strong).
export const COLOR_DRYING_GRAPH_REGION_POWER_FAIL_DARK = "#ff6961" + TRANSPARENCY_20;
export const COLOR_DRYING_GRAPH_REGION_DRYING_PAUSE_DARK = COLOR_BLUE_80 + TRANSPARENCY_20;

export const COLOR_DRYING_GRAPH_PHASE_INFO_1 = COLOR_BLUE_80 + TRANSPARENCY_80;
export const COLOR_DRYING_GRAPH_PHASE_INFO_2 = COLOR_BLUE_65 + TRANSPARENCY_80;
export const COLOR_DRYING_GRAPH_PHASE_INFO_3 = COLOR_BLUE_45 + TRANSPARENCY_80;
export const COLOR_DRYING_GRAPH_PHASE_INFO_4 = COLOR_BLUE_25 + TRANSPARENCY_80;

export const COLOR_DRYING_GRAPH_PHASE_INFO_POST_DRYING = COLOR_GREEN_25 + TRANSPARENCY_80;
export const COLOR_DRYING_GRAPH_PHASE_INFO_WARNING = "#fff600" + TRANSPARENCY_70;
export const COLOR_DRYING_GRAPH_PHASE_INFO_ERROR = "#ff6961" + TRANSPARENCY_70;

export const PHASE_ANNOTATION_COLORS = [
  COLOR_DRYING_GRAPH_PHASE_INFO_1,
  COLOR_DRYING_GRAPH_PHASE_INFO_2,
  COLOR_DRYING_GRAPH_PHASE_INFO_3,
  COLOR_DRYING_GRAPH_PHASE_INFO_4,
];

// Scheduling Colors
export const COLOR_SCHEDULING_CHECKBOX = COLOR_PRIMARY;

export const COLOR_SCHEDULING_TASK_LEAK_DETECTION = "#b1d2ee";
export const COLOR_SCHEDULING_TASK_DAMAGE_ASSESSMENT = "#9bc53d";
export const COLOR_SCHEDULING_TASK_DRYING_SETUP = "#ff967f";
export const COLOR_SCHEDULING_TASK_INTERMEDIATE_MEASUREMENT = "#fde74c";
export const COLOR_SCHEDULING_TASK_DRYING_CONCLUSION = "#ffd580";
export const COLOR_SCHEDULING_TASK_REPAIR = "#41521f";

export const COLOR_SCHEDULING_TIMLINE_VISIBLE_AREA_ONE_DAY = COLOR_STANDARD_WHITE;
export const COLOR_SCHEDULING_TIMLINE_VISIBLE_AREA_OTHER = "rgba(255,136,87,0.3)";

// Settings Colors
export const COLOR_ALL_DEVICES_IMPORT_UPLOAD_BOX_BORDER = "#a9a9a9" + TRANSPARENCY_60;
export const COLOR_ALL_DEVICES_IMPORT_UPLOAD_BOX_BACKGROUND = COLOR_RED_15;
// The light-mode box is a pale red tint that carries dark text; in dark mode it would be a bright
// panel with the theme's white text on it, so the drop zone becomes a raised surface instead.
export const COLOR_ALL_DEVICES_IMPORT_UPLOAD_BOX_BORDER_DARK = COLOR_GREY_50 + TRANSPARENCY_40;
export const COLOR_ALL_DEVICES_IMPORT_UPLOAD_BOX_BACKGROUND_DARK = COLOR_SURFACE_ELEVATED_DARK;

export const COLOR_BUTTON_SETTINGS_EDIT = COLOR_BUTTON_YELLOW;
export const COLOR_BUTTON_SETTINGS_SAVE = COLOR_BUTTON_GREEN;
export const COLOR_BUTTON_SETTINGS_CANCEL = COLOR_BUTTON_RED;

// AI Prediction Colors
export const COLOR_AI_PREDICTION_GOOD = COLOR_GREEN_100;
export const COLOR_AI_PREDICTION_NEEDS_REVIEW = COLOR_YELLOW_105;
export const COLOR_AI_PREDICTION_CRITICAL = COLOR_RED_100;
export const COLOR_AI_PREDICTION_BAR_PRIMARY = COLOR_BLUE_100;
export const COLOR_AI_PREDICTION_BAR_GREEN = COLOR_GREEN_100;
export const COLOR_AI_PREDICTION_BAR_GREY = COLOR_GREY_100;
export const COLOR_AI_PREDICTION_BAR_TRACK = COLOR_GREY_25;

// Sensor Usage Colors (for MESS/PROG/REF font color on grey backgrounds in legend and column headers)
export const COLOR_SENSOR_USAGE_MEASUREMENT = COLOR_GREEN_50;
export const COLOR_SENSOR_USAGE_PROGRAM = COLOR_YELLOW_50;
export const COLOR_SENSOR_USAGE_REFERENCE = "#e0e0e0";

// Sensor Badge Colors (legend column header icons)
export const COLOR_SENSOR_BADGE_WARNING = COLOR_RED_100;
export const COLOR_SENSOR_BADGE_INFO = COLOR_BLUE_100;

// Import Status Colors (DataViewer STATUS column)
export const COLOR_IMPORT_STATUS_NEW = COLOR_GREEN_100;
export const COLOR_IMPORT_STATUS_UPDATED = COLOR_BLUE_100;
export const COLOR_IMPORT_STATUS_NO_CHANGE = COLOR_GREY_100;
export const COLOR_IMPORT_STATUS_ERROR = COLOR_RED_100;
export const COLOR_IMPORT_STATUS_DUPLICATE = COLOR_YELLOW_105;
export const COLOR_IMPORT_STATUS_DELETED = COLOR_GREY_100;
export const COLOR_IMPORT_STATUS_RESTORED = COLOR_TEAL_100;

// Time Tracking History Chip Colors
export const COLOR_TIME_TRACKING_CHIP_PROJECT = COLOR_GREEN_100;
/** Project/task chip when the entry is still active (RUNNING or SUSPENDED) — lighter green. */
export const COLOR_TIME_TRACKING_CHIP_PROJECT_ACTIVE = COLOR_GREEN_50;
/**
 * Text color for the active (light green) project chip. Dark green instead of white:
 * white on the pale `GREEN_50` background is too low-contrast and reads as disabled.
 */
export const COLOR_TIME_TRACKING_CHIP_PROJECT_ACTIVE_TEXT = COLOR_GREEN_900;
export const COLOR_TIME_TRACKING_CHIP_GENERAL = COLOR_BLUE_100;
export const COLOR_TIME_TRACKING_CHIP_PAUSE = COLOR_BROWN_105;
export const COLOR_TIME_TRACKING_CHIP_TRAVEL = COLOR_YELLOW_105;
/**
 * A drive that is still running or was interrupted, as opposed to one that arrived.
 *
 * Pale against the solid finished chip, exactly as {@link COLOR_TIME_TRACKING_CHIP_PROJECT_ACTIVE} is
 * pale against {@link COLOR_TIME_TRACKING_CHIP_PROJECT}: one convention for "not concluded", whichever
 * kind of entry it is. Needed because IRES Work started recording `endReason` on drives (UNTERBRECHEN
 * leaves SUSPENDED), and until this the two looked identical here.
 */
export const COLOR_TIME_TRACKING_CHIP_TRAVEL_ACTIVE = COLOR_YELLOW_50;
/** Text on the pale travel chip: white on #ffde7f is unreadable, as it is on the pale project chip. */
export const COLOR_TIME_TRACKING_CHIP_TRAVEL_ACTIVE_TEXT = COLOR_BROWN_105;
/** Travel whose destination is the project ("Fahrt zum Projekt" / "Anfahrt") — green, like project work. */
export const COLOR_TIME_TRACKING_CHIP_TRAVEL_PROJECT = COLOR_GREEN_100;
export const COLOR_TIME_TRACKING_CHIP_INTERRUPTION = COLOR_GREY_100;
export const COLOR_TIME_TRACKING_CHIP_PROJECT_NAME = COLOR_GREY_100;
export const COLOR_TIME_TRACKING_DAY_MARKER_BACKGROUND = COLOR_GREY_15;
export const COLOR_TIME_TRACKING_DAY_MARKER_TEXT = COLOR_STANDARD_BLACK;
export const COLOR_TIME_TRACKING_SUB_ENTRY_BACKGROUND = COLOR_GREY_15;
export const COLOR_TIME_TRACKING_SUB_ENTRY_TEXT = COLOR_GREY_100;
export const COLOR_TIME_TRACKING_DAY_CLOSED = COLOR_GREEN_50;
export const COLOR_TIME_TRACKING_DAY_OPEN = COLOR_YELLOW_50;
export const COLOR_TIME_TRACKING_HOVER = COLOR_GREY_15;
export const COLOR_TIME_TRACKING_BORDER = COLOR_GREY_25;
export const COLOR_TIME_TRACKING_EDITED_TIME = COLOR_RED_100;

/**
 * "A new version is available" banner. A muted informational surface rather than an alert colour:
 * the update is an offer the user may ignore indefinitely, not a warning.
 */
export const COLOR_APP_UPDATE_BANNER_BACKGROUND = COLOR_BLUE_15;
export const COLOR_APP_UPDATE_BANNER_BACKGROUND_DARK = COLOR_SURFACE_ELEVATED_DARK;
export const COLOR_APP_UPDATE_BANNER_BORDER = COLOR_BLUE_50;
export const COLOR_APP_UPDATE_BANNER_BORDER_DARK = COLOR_BLUE_80;
